/**
 * GF Universal Toast
 * Provides a global method to show toast notifications.
 * Usage: window.GFToast.show(imageUrl, productTitle);
 */

window.GFToast = {
    show: function (image_url, title) {
        // Remove existing toast if any (to prevent stacking overflow or just cleaner UI)
        const existing = document.querySelector('.gf-toast');
        if (existing) {
            existing.remove();
        }

        // Create Toast Element
        const toast = document.createElement('div');
        toast.className = 'gf-toast';

        let imgHtml = '';
        if (image_url) {
            imgHtml = `<img src="${image_url}" style="width: 40px; height: 40px; border-radius: 6px; object-fit: cover;" alt="">`;
        }

        // Use SVG for icon to ensure no external dependency on font icons
        toast.innerHTML = `
           ${imgHtml}
           <div class="gf-toast-content">
               <span class="gf-toast-title">Agregado al Carrito</span>
               <span class="gf-toast-sub">${title}</span>
           </div>
           <div class="gf-toast-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
           </div>
        `;

        document.body.appendChild(toast);

        // Animate In with slight delay to ensure render
        requestAnimationFrame(() => {
            toast.classList.add('active');
        });

        // Removal Sequence
        setTimeout(() => {
            toast.classList.remove('active');
            setTimeout(() => {
                if (toast.parentElement) toast.parentElement.removeChild(toast);
            }, 500); // Wait for transition
        }, 4000); // 4 seconds visible
    }
};
